import { useParams,useNavigate } from "react-router-dom";
import { Card, Box, Typography,Button} from "@mui/material";
import ButtonComponent from "../../../components/common/button/Button";
import DataTable from "../../../components/common/datatable/DataTable";
import { useState,useEffect,useMemo,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import TopSection from "../../LT/TopSection";
//import { setSelectedItem } from "../../../redux/actions/";
//import { postData } from "../../../redux/actions/dataSlice";
const RiskDetail = () => {
  const { risk } = useParams(); // "highrisk" | "mediumrisk" | "lowrisk" | "nonerisk"
const navigate = useNavigate();
const riskKey = String(risk || "highrisk").toLowerCase();
const [selectedRows, setSelectedRows] = useState([]);
const gridRef = useRef();
const [gridApi, setGridApi] = useState();
const dispatch = useDispatch();
const isPushDisabled = !selectedRows || selectedRows.length === 0;
const handleMaterialClick = (row) => {
    const material = row?.material;
    const plant = row?.plant;
    if (!material || !plant) return;

    navigate(
      `/dashboard/material/${encodeURIComponent(material)}/${encodeURIComponent(plant)}`,
      {
        state: {
          supplier: row?.supplier,
          unit: row?.unit,
          description: row?.description,
        },
      }
    );
  };
const pushLabel = isPushDisabled
  ? "Push to IBP"
  : `Push to IBP(${selectedRows.length})`;
  // Map URL → display metadata and filters
  const cfg = {
    highrisk:  { title: "High Risk",   riskStatus: "High Risk" },
    mediumrisk:{ title: "Medium Risk", riskStatus: "Medium Risk" },
    lowrisk:   { title: "Low Risk",    riskStatus: "Low Risk" },
    nonerisk:  { title: "None Risk",   riskStatus: "None Risk" },
  }[riskKey] || { title: "High Risk", riskStatus: "High Risk" };
 
  const riskColorMap = {
    highrisk:   "#d32f2f", // red
    mediumrisk: "#ed6c02", // orange
    lowrisk:    "#2e7d32", // green
    nonerisk:   "#757575", // gray
  };
  const borderColor = riskColorMap[riskKey] || "#d32f2f";
 
 const allRows = [
    { plant: "PLT-1001", supplier: "Supplier A", material: "MAT-0001", description: "PET Resin Grade A", unit: "KG", pdt: 7, earlierStockoutWeek: 1, stockoutPdtHorizon: 800, uncoveredPercent: "2026-01-15", riskStatus: "High Risk", breachWeek: -400 },
    { plant: "PLT-1002", supplier: "Supplier B", material: "MAT-0002", description: "Bottle Caps Red", unit: "EA", pdt: 5, earlierStockoutWeek: 5, stockoutPdtHorizon: 48000, uncoveredPercent: "2026-01-18", riskStatus: "Medium Risk", breachWeek: -2000 },
    { plant: "PLT-1003", supplier: "Supplier C", material: "MAT-0003", description: "Carton Boxes 24", unit: "EA", pdt: 3, earlierStockoutWeek: 8, stockoutPdtHorizon: 8200, uncoveredPercent: "2026-01-20", riskStatus: "Low Risk", breachWeek: 200 },
    { plant: "PLT-1004", supplier: "Supplier D", material: "MAT-0004", description: "Labels Glossy", unit: "EA", pdt: 4, earlierStockoutWeek: 1, stockoutPdtHorizon: 15000, uncoveredPercent: "2026-01-22", riskStatus: "None Risk", breachWeek: 0 },
    { plant: "PLT-1005", supplier: "Supplier E", material: "MAT-0005", description: "Sugar Refined", unit: "KG", pdt: 10, earlierStockoutWeek: 2, stockoutPdtHorizon: 20000, uncoveredPercent: "2026-01-16", riskStatus: "High Risk", breachWeek: 4 },
    { plant: "PLT-1006", supplier: "Supplier F", material: "MAT-0006", description: "Citric Acid", unit: "KG", pdt: 6, earlierStockoutWeek: 6, stockoutPdtHorizon: 5900, uncoveredPercent: "2026-01-17", riskStatus: "Medium Risk", breachWeek: 1 },
    { plant: "PLT-1007", supplier: "Supplier G", material: "MAT-0007", description: "Flavor Base Cola", unit: "KG", pdt: 8, earlierStockoutWeek: 4, stockoutPdtHorizon: 4300, uncoveredPercent: "2026-01-19", riskStatus: "Low Risk", breachWeek: 100 },
    { plant: "PLT-1008", supplier: "Supplier H", material: "MAT-0008", description: "Glass Bottles 500", unit: "EA", pdt: 12, earlierStockoutWeek: 3, stockoutPdtHorizon: 30000, uncoveredPercent: "2026-01-21", riskStatus: "None Risk", breachWeek: 4 },
    { plant: "PLT-1009", supplier: "Supplier I", material: "MAT-0009", description: "CO2 Industrial", unit: "KG", pdt: 2, earlierStockoutWeek: 9, stockoutPdtHorizon: 7000, uncoveredPercent: "2026-01-14", riskStatus: "High Risk", breachWeek: 3 },
    { plant: "PLT-1010", supplier: "Supplier J", material: "MAT-0010", description: "Shrink Wrap 500mm", unit: "EA", pdt: 5, earlierStockoutWeek: 12, stockoutPdtHorizon: 11800, uncoveredPercent: "2026-01-15", riskStatus: "Medium Risk", breachWeek: 2 },
    { plant: "PLT-1011", supplier: "Supplier K", material: "MAT-0011", description: "HDPE Caps Black", unit: "EA", pdt: 7, earlierStockoutWeek: 22, stockoutPdtHorizon: 22200, uncoveredPercent: "2026-01-16", riskStatus: "Low Risk", breachWeek: 2 },
    { plant: "PLT-1012", supplier: "Supplier L", material: "MAT-0012", description: "Pallets Euro", unit: "EA", pdt: 9, earlierStockoutWeek: 3, stockoutPdtHorizon: 3000, uncoveredPercent: "2026-01-17", riskStatus: "None Risk", breachWeek: 1 },
    { plant: "PLT-1013", supplier: "Supplier M", material: "MAT-0013", description: "Sweetener HFCS", unit: "KG", pdt: 11, earlierStockoutWeek: 18, stockoutPdtHorizon: 15000, uncoveredPercent: "2026-01-18", riskStatus: "High Risk", breachWeek: 5 },
    { plant: "PLT-1014", supplier: "Supplier N", material: "MAT-0014", description: "Aluminum Cans 330", unit: "EA", pdt: 6, earlierStockoutWeek: 8, stockoutPdtHorizon: 79000, uncoveredPercent: "2026-01-19", riskStatus: "Medium Risk", breachWeek: 4 },
    { plant: "PLT-1015", supplier: "Supplier O", material: "MAT-0015", description: "Bottle Preforms", unit: "EA", pdt: 5, earlierStockoutWeek: 4, stockoutPdtHorizon: 40500, uncoveredPercent: "2026-01-20", riskStatus: "Low Risk", breachWeek: 5 },

    { plant: "PLT-1017", supplier: "Supplier Q", material: "MAT-0017", description: "Phosphoric Acid", unit: "KG", pdt: 9, earlierStockoutWeek: 7, stockoutPdtHorizon: 6000, uncoveredPercent: "2026-01-22", riskStatus: "High Risk", breachWeek: 3 },
    { plant: "PLT-1018", supplier: "Supplier R", material: "MAT-0018", description: "PET Flakes", unit: "KG", pdt: 8, earlierStockoutWeek: 9, stockoutPdtHorizon: 8800, uncoveredPercent: "2026-01-23", riskStatus: "Medium Risk", breachWeek: 2 },
 { plant: "PLT-1019", supplier: "Supplier S", material: "MAT-0019", description: "Ink Black", unit: "KG", pdt: 4, earlierStockoutWeek: 120, stockoutPdtHorizon: 1250, uncoveredPercent: "2026-01-24", riskStatus: "Low Risk", breachWeek: 2 },
 
  ];

  // --- Column defs for RiskDetail: fewer columns + a computed column ---
  // We intentionally omit `riskStatus` (it's obvious from header) and include a computed 'Days Until Conf'.
  const columnDefs = [
      {
    headerName: '',
    field: '__select__',
    checkboxSelection: true,
    headerCheckboxSelection: true,
    pinned: 'left',
    width: 40,
    suppressSizeToFit: true,
    sortable: false,
    filter: false,
    resizable: false,
  },
    { headerName: "Plant", field: "plant", filter: true, width: 120 },
    { headerName: "Supplier", field: "supplier", filter: true, width: 150 },
    {
      headerName: "Material",
      field: "material",
      filter: true,
      width: 140,
      cellRenderer: (params) => {
        const row = params.data;
        return (
          <span
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e.stopPropagation();
              handleMaterialClick(row);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleMaterialClick(row);
              }
            }}
            style={{
              color: "#1976d2",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {params.value}
          </span>
        );
      },
    
    },
    { headerName: "Description", field: "description", filter: false },
    { headerName: "Unit", field: "unit", filter: false, width: 90 },
    { headerName: "PDT", field: "pdt", filter: false, width: 90 },
    { headerName: "Earlier stockout week", field: "earlierStockoutWeek", filter: false, width: 120 },
    { headerName: "Stockout pdt horizon", field: "stockoutPdtHorizon", filter: false, width: 140 },
    { headerName: "Uncovered %", field: "uncoveredPercent", filter: false, width: 130 },
    { headerName: "Breach Week", field: "breachWeek", filter: false, width: 130 },
    { headerName: "Risk Status", field: "riskStatus", filter: false, width: 130 },
  ];
  const [rows, setRows] = useState([]);
  

  useEffect(() => {
    // Filter the dataset by the human-readable riskStatus that ARDashboard uses
    const filtered = allRows.filter((r) => r.riskStatus === cfg.riskStatus);
    setRows(filtered);
  }, [risk, cfg.riskStatus]);

  // pagination page size
  const pageSize = 30;

  // estimate sizes and decide table height
  const tableHeight = useMemo(() => {
    const ROW_EST = 38; // pixels per row (estimate; adjust if your row styling differs)
    const HEADER_AND_TOOLBAR = 120; // header + toolbar + potential pagination footer
    const MIN_HEIGHT = 200;
    const MAX_HEIGHT = 880;
    const computed = rows.length > 0 ? rows.length * ROW_EST + HEADER_AND_TOOLBAR : MIN_HEIGHT;
    return Math.max(Math.min(computed, MAX_HEIGHT), MIN_HEIGHT);
  }, [rows]);

  const paginationEnabled = rows.length > pageSize;
  const rowSelection = "multiple";
  const isRowSelectable=(rowNode)=>{
    return true;
  }
   const selectionColumnDef = useMemo(
  () => ({
    headerCheckboxSelection: true,
    checkboxSelection: true,
    pinned: "left",
    width: 40,
  }),
  []
);
 const onGridReady = (params) => {
        setGridApi(params?.api);
        gridRef.current = params?.api;
        setSelectedRows([])
    }
        const onSelectionChanged = (params) => {
        const filteredSelectedRows = [];
        params?.api?.forEachNodeAfterFilter((node) => {
            if (node.isSelected()) {
                filteredSelectedRows.push(node.data);
            }
        });
        setSelectedRows(filteredSelectedRows);
      //  dispatch(setSelectedItem(filteredSelectedRows));
    }


  // TODO: Fetch/compute data based on cfg.riskStatus and render your existing UI here.
  // Keep your screen-2 UI identical; just swap the data using cfg.riskStatus.
const handleReturn = () => navigate("/dashboard");
const handlePush = () => {
    // TODO: implement your push action
    // e.g., trigger workflow, open modal, navigate, etc.
    // For now, just a placeholder:
 //    const items = selectedRows.map(({ plant, material, supplier }) => ({
 //   plant,
 //   material,
 //   supplier,
 //  }));
    
    {/*} Prefer sending minimal identifiers
+/*}  const items = selectedRows.map(({ plant, material, supplier }) => ({
+    plant,
+    material,
+    supplier,
+  }));
dispatch(
+    postData({
+      dynamicEndpoint: "ibp/push", // TODO: replace with your actual endpoint
+      data: {
+        riskStatus: cfg.riskStatus,
+        items,
+      },
+    })
+  )
+    .unwrap()
+    .then((res) => {
+      // Optional: toast, navigate, or reset selection
+      // navigate("/dashboard");
+    })
+    .catch((err) => {
+      console.error("IBP push failed:", err);
+    });*/}
  };
  return (
    <>
    <TopSection
  labelList={[
    { title: "Home", path: "/dashboard" },
    { title: "Dashboard", path: "/dashboard" },
    { title: cfg.title }, // e.g., "High Risk"
  ]} 
  hideHeader={true}
/>
    <Box sx={{ width: "100%" }}>
      
      <Card
       // elevation={1}
        sx={{
          width: "80%",
          borderRadius: 2,
          margin: "2px auto",
          marginBottom: 2,
          padding: 2,
          minHeight: 96,        // short height
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderLeft: `4px solid ${borderColor}`,
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
          <Typography variant="body2" sx={{ fontWeight: 600 ,color: borderColor}}>
            {cfg.riskStatus}
          </Typography>
          <Typography variant="h6">
            Detailed Matrix Risk Index
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Multi factor pdt horizon
          </Typography>
        </Box>

        <Box sx={{ display: "flex", gap: 1 }}>
          <ButtonComponent
           label={pushLabel}
  type="primary"
  bgColor="#f53c00"
  color="white"
  onClick={handlePush}
  disabled={isPushDisabled}
                            >                  
          </ButtonComponent>
        </Box>
      </Card>
     <Box sx={{ width: "83%", margin: "4px auto" }}>
        <DataTable
          columns={columnDefs}
          rows={rows}
          paginationProp={paginationEnabled}
          paginationPageSize={pageSize}
          paginationPageSizeSelector={[30, 50, 100, 500, 2000]}
          defaultColDef={{
            resizable: true,
            filter: "agSetColumnFilter",
            filterParams: {
              excelMode: "windows",
              suppressMiniFilter: false,
              buttons: ["apply", "reset"],
            },
          }}
          onGridReady={onGridReady}
          height={tableHeight}
          onSelectionChanged={onSelectionChanged}
          headerCheckboxSelectionFilterOnly={true}
          rowSelection={rowSelection}
          isRowSelectable={isRowSelectable}
          selectionColumnDef={selectionColumnDef}
        />
      </Box>
      
    </Box>
    </>
  );
};

export default RiskDetail;